import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default function DefectsPlaceholder() {
    return _jsx("div", { className: "loading__item", children: _jsx("div", { className: "ph-col-12", children: _jsx("div", { className: "loading__row", children: _jsx("div", { className: "ph-col-12 bigger" }) }) }) });
}
